<div class="modal-header">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
</div>
@if(isLoading){
<div class="loading-div w-100 d-flex justify-content-center align-items-center" *ngIf="isLoading">
  <app-loading [text]="'Loading...'"></app-loading>
</div>
} @else{
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <app-zorro-table [enableHorizontalScroll]="true" [columns]="configs.columns"
        [data]="configs.data" [options]="tableOptions">
      </app-zorro-table>
    </div>
  </div>
</div>
}